import { getImageServer } from 'www/utils/get-image-server';
import { getDomain } from 'www/utils/get-domain';

const apiHost = `https://www.${getDomain()}medscape.com`;
const saveAPI_URL = apiHost + '/api/v1/useractivityservice';
const fetch_ep = '/get?tags=video';
const save_ep = '/save';
const unsave_ep = '/updateactiveflag';

export const gotToWatchList = apiHost + '/saved';

const saveConfig = ({ title, url, articleId, thumbnail }) => {
  let config = [
    {
        active: 1,
        jsonData: 
            {
                aspenArticle: false,
                articleId,
                title,
                postingDate: new Date(),
                savedDate: new Date(),
                url,
                thumbnail: getThumbnail(thumbnail),
            },
        tagNames: "video",
        subDomain: "www",
        scode: "msp",
    },
  ];
  return config;
};

const unSaveConfig = (userTxnId)=>{
    return [{ active: 0, tagNames: "video", userTxnId }];
}

const getThumbnail = (thumbnail) => {
    let imgPath = thumbnail;

    if (imgPath.startsWith("en/")) {
        imgPath = imgPath.replace("en/", "");
    }

    if (!imgPath.startsWith('http') && !imgPath.startsWith('//')) {
        imgPath = `https://${getImageServer()}/${imgPath}`;
    }

    return imgPath;
}

export const fetchSaveAPI =  () =>{
     return fetch(`${saveAPI_URL}${fetch_ep}`, {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => response.json())
        .catch((error) => console.error("Error Fetching SavedItems:", error));
}
export const saveVideoAPI = (config) => {
    return fetch(`${saveAPI_URL}${save_ep}`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(saveConfig(config)),
        }).then((response) => response.json())
        .catch((error) => console.error("Error Save Video:", error));
}
export const unsaveVideoAPI = (userTxnId) =>{
   return fetch(`${saveAPI_URL}${unsave_ep}`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(unSaveConfig(userTxnId)),
        }).then((response) => response.json())
        .catch((error) => console.error("Error Unsave Video:", error));
}

export function enableVideoSaver(){

    if(typeof mscpA2A !== 'undefined') {
        return;
    }
    
    const hasClasses = document.querySelector("#bodypadding").classList;

    const isRecapVideo =  window._isRecap &&
        !hasClasses.contains("recaptext") && 
        !hasClasses.contains("recapguidance");

    const isMdAngleOrCarecues = window._ismdAngle || window._isCareCues || window._isODP;
    
    return hasClasses.contains("logged-in") && (isMdAngleOrCarecues || isRecapVideo);
}
